// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'Balance of VAT Due for each Member State',
    [LanguagesEnum.Greek]: 'Balance of VAT Due for each Member State',
  },
  subtitle: {
    [LanguagesEnum.English]:
      'This list shows the balance of VAT Due for each Member State including all the Corrections you have made from VAT Return Periods of the past 3 Years.',
    [LanguagesEnum.Greek]:
      'This list shows the balance of VAT Due for each Member State including all the Corrections you have made from VAT Return Periods of the past 3 Years.',
  },
};

export default CONFIGURATION;
